

import { getLink } from '../../../../utils/utils';

import author from './author';

import formula from '../../../images/formula.png';


const content = {
	rus: (
		`
		<div style="text-align: justify;">
		
			<p class="mb-3">
				Наша лаборатория давно занимается проблемами доместификации. 
				Как известно, на разных планетах живут разные животные, и они в разной мере пригодны для использования в разных областях народного хозяйства. 
				Так, население планеты ₡ поставляет нам прекрасную шерсть для космических перелётов. 
				Эта планета не имеет атмосферы и открыта прямому влиянию космических излучений. 
				Поэтому жители её покрыты толстым слоем непроницаемого для этих лучей длиннейшего плотного меха. 
				Мы с ними договорились об обмене, поставляя им через несколько звеньев нашей межгалактической системы необходимый им для роста волосяного покрова плутоний, 
				а они благодаря ему вырастили себе чрезмерно длинную шерсть, излишки которой охотно отдают нам. 
				А мы плетём из неё индивидуальные скафандры, в которых можно совершать недалёкие межпланетные прогулки, например, 
				на дачу на планете ₩ или на морские купания на планету-океан Акварис, не прибегая к помощи тяжеловесных космических кораблей: залез в мягкий и уютный кокон, 
				взял с собой гравицапу – и плыви куда хочешь! 
			</p>
			
			<p class="mb-3">
				Или возьмём планету ₪, с которой мы обмениваемся эцамбом: у нас это побочный продукт при переработке высоколегированного амбиона, 
				а на планете ₪ это компонент питания тамошней расы. 
				Они нам за это поставляют продукт своей жизнедеятельности <img src="${formula}" style="width: 200px;margin: 10px 0;" alt="Формула удобрения" className="formula_img" />, из которого мы получаем удобрение для выращивания прекрасных цветов с планеты ₻. 
				Эти цветы украшают у нас все улицы,и, что интересно, на планете ₻ эти цветы растут на совсем другой почве, и <img src="${formula}" style="width: 200px;margin: 10px 0;" alt="Формула удобрения" className="formula_img" /> на них там действует угнетающе! 
				Зато у нас и на нескольких близких нам по составу планетах просто процветает эта чудесная флора! 
				Чем наши соседи там с ними обмениваются, я даже не знаю: слишком много миров в нашей системе, за всеми не уследишь…
			</p>
			
			<p class="mb-3">
				Мы вот сейчас занимаемся планетой ₰, где её обитатели вырабатывают индол и скатол для нашей химической промышленности. 
				Обмена в полном смысле у нас с ними нет: они слаборазвиты и ещё не доросли до межгалактического сотрудничества. 
				Пока что они развивают машинную цивилизацию; но их игры подчас заходят далеко, и не исключена возможность, 
				что в конце концов они доиграются и уничтожат друг друга; а зачем нам это надо? 
				Каждая планета должна приносить какую-то пользу Системе.
			</p>
			
			<p class="mb-3">
				И вот нам поручили доместифицировать, т.е. привести в управляемое и полезное Космосу состояние население этой планеты, 
				раз его собственное развитие к такому благоприятному для всех (и для него в том числе) результату не привело.
			</p>
			
			<p class="mb-3">
				Как известно, при доместификации животные увеличиваются в размерах, их мясо становится более жирным, ослабевают мускулы, пропадает инстинкт материнства. 
				Ну, четверо-, шести- и вовсе безногие обитатели этой планеты исправно вырабатывают то, что нам надо, 
				и только страдают от неправильного поведения двуногих. 
				Значит, заняться надо исключительно вертикальными двуногими с остатками шерсти только на апикальной точке. 
				Мы вбросили в их культуру кое-что, на что они были падки: приманки сладкой жизни без напряжения, без стремлений, без усилий. 
				И не могу не похвастаться: буквально за пару аигов (где-то полвека по их счёту) произошли все типичные изменения доместификации: акселерация, 
				атрофирование как умственной, так и физической активности, угасание материнского инстинкта и стремления к размножению. 
				Можно сказать, что наш отдел с честью выполнил задачу и достоин солидной премии (шучу; хотя впрочем…). 
			</p>
			
			<p class="mb-3">
				А двуногие на той планете, если не случится вдруг какой-то вспышки агрессии и они не уничтожат сами себя (что было бы досадно), должны, в принципе, 
				следовать по проложенной нами колее и продолжать вырабатывать (экскрецировать) те вещества, для производства которых они и были созданы. 
				Как показывает предыдущий опыт их существования, 
				до уровня самостоятельного развития и гармоничного сотрудничества в космическом масштабе они ещё далеко не доросли. 
			</p>
			<p class="mb-3 text-end">
				Зав. Отделом доместификации Института космического развития
			</p>
			<p class="mb-3">
				(подпись)
			</p>
			
			
		</div>
		`
	)
}

const itemName = {
	rus: `Заметка из научно-популярного журнала`
}


const item = {
	itemlink: getLink(itemName.rus.replace('...', '')),
	rus: {
		itemName: itemName.rus,
		itemContent: content.rus,
		itemAuthor: author.rus
	}
}

export default item;